import React from "react";

interface popupProps {
  header: any;
  content: React.ReactNode;
  footer?: any;
}

const Popup: React.FC<popupProps> = ({
  header,
  content,
  footer = null
}) => {
  return (
    <div className="popup-container">
      <div className={"popup"}>
        {header}
        {content}
        {footer === null ? null : footer}
      </div>
    </div>
  );
};

export default Popup;
